import { getTimestamp
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { NEGATIVE, POSITIVE } from 'conversations-message-history/customer-agent-feedback-message/constants/messageTypes';
import { isCustomerAgentFeedbackMessageRecord } from 'conversations-message-history/customer-agent-feedback-message/operators/isCustomerAgentFeedbackMessage';
import { getMessages } from 'conversations-message-history/thread-history/operators/getters';
import { isMessagesCollection } from '../types';
const EMPTY = {
  sentiment: null,
  latestFeedbackMessageId: null
};
const collectFeedback = (messages, agentMessageId, out) => {
  if (!isMessagesCollection(messages)) {
    return;
  }
  messages.forEach(msg => {
    var _msg$type, _getTimestamp;
    if (!isCustomerAgentFeedbackMessageRecord(msg)) {
      return;
    }
    if (msg.inResponseToMessageId !== agentMessageId) {
      return;
    }
    const id = msg.id || null;
    if (!id) {
      return;
    }
    out.push({
      id,
      type: (_msg$type = msg.type) !== null && _msg$type !== void 0 ? _msg$type : null,
      timestamp: (_getTimestamp = getTimestamp(msg)) !== null && _getTimestamp !== void 0 ? _getTimestamp : 0
    });
  });
};
export const getExistingFeedback = (agentMessageId, unpublishedMessages, threadHistoryData) => {
  if (!agentMessageId) {
    return EMPTY;
  }
  const entries = [];
  collectFeedback(threadHistoryData ? getMessages(threadHistoryData) : null, agentMessageId, entries);
  collectFeedback(unpublishedMessages, agentMessageId, entries);
  if (entries.length === 0) {
    return EMPTY;
  }
  entries.sort((a, b) => a.timestamp - b.timestamp);
  const latest = entries[entries.length - 1];
  const sentiment = latest.type === POSITIVE || latest.type === NEGATIVE ? latest.type : null;
  return {
    sentiment,
    latestFeedbackMessageId: latest.id
  };
};